module.exports = __webpack_public_path__ + "img/7f1.e905d006.jpg";